import { useTranslation } from 'next-i18next';
import React from 'react';
import { SearchLocationInput } from '../../atoms/autocomplete-places/SearchLocationInput';

export const ValLanding: React.FC<{ onSelected: (query: string) => void }> = ({
  onSelected,
}) => {
  const { t } = useTranslation(['valutatore']);

  return (
    <div className="align-items-center">
      <div className="valutatore__title">{t('title')}</div>
      <div
        className="valutatore__subtitle"
        dangerouslySetInnerHTML={{
          __html: t('subtitle'),
        }}
      ></div>
      <SearchLocationInput onSelected={(query) => onSelected(query)} />
      <div
        className="valutatore__subtitle4"
        style={{ marginTop: '1rem', fontSize: '0.8rem', color: '#ffffff' }}
      >
        {t('subtitle4')}
      </div>
    </div>
  );
};
